'use strict';

angular.module('admin').controller('AdminUserMTProfilesController',
	['$scope', 'AdminData', 'Authentication', 'Utilities', 'SweetAlert', '$stateParams', '$window',
		function ($scope, AdminData, Authentication, Utilities, SweetAlert, $stateParams, $window) {
			$scope.authentication = Authentication;
			$scope.data = {
				userId: $stateParams.userId,
				userInfo: undefined,
				userMtProfiles: [],
				selectMTProfileId: null,
				mtProfiles: [],
				mtProfilesFiltered: [],
				filterText: '',
				timeout: undefined,
				timer: 1000,
				isLoading: true
			};

			/**
			 * Load all the data
			 */
			$scope.init = function () {
				$scope.data.isLoading = true;

				AdminData.userInfo({userId: $scope.data.userId}, function (userInfo) {
					$scope.data.userInfo = userInfo;
					$scope.data.newPlan = userInfo._planInfo.id;
				}, function (err) {
					Utilities.showMessage(
						'Problem!',
						'Problem loading user info',
						'error'
					);
				});

				AdminData.getUserMtProfiles({ userId: $scope.data.userId }, function (userProfiles) {
					$scope.data.userMtProfiles = (userProfiles) ? userProfiles : [];
				}, function (err) {
					$scope.data.userMtProfiles = [];
					Utilities.showMessage(
						'Problem!',
						'Problem loading user MT profiles',
						'error'
					);
				});

				AdminData.getAllMTProfiles({}, function (profiles) {
					$scope.data.mtProfiles = profiles.sort(function (a, b) {
						return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
					});
					$scope.data.mtProfilesFiltered = $scope.data.mtProfiles;
					$scope.data.isLoading = false;
				}, function (err) {
					Utilities.showMessage(
						'Problem!',
						'Problem loading MT profiles',
						'error'
					);
					$scope.data.isLoading = false;
				});
			};

			/**
			 * filter MT profile list by name
			 */
			$scope.filterItem = function () { 
				clearTimeout(this.timeout);
				this.timeout = setTimeout(() => {
					if (!$scope.data.filterText) {
						$scope.data.mtProfilesFiltered = $scope.data.mtProfiles;
					} else {
						$scope.data.filterText.toLowerCase();
						$scope.data.mtProfilesFiltered = $scope.data.mtProfiles.filter(
							p => p.name.toLowerCase().includes($scope.data.filterText.toLowerCase())
						);
					}
					$scope.$apply();
				}, $scope.data.timer);
			};

			/**
			 * add MT profile to teh user
			 */
			$scope.addMTProfile = function () {
				const profileId = $scope.data.selectMTProfileId;

				if (!profileId) return;

				const index = $scope.data.userMtProfiles.findIndex(p => p.profileId === profileId);
				if (index > -1) {
					SweetAlert.swal(
						{
							title: 'Problem!',
							text: 'This profile is alredy added to the user!',
							type: 'warning',
							showCancelButton: false
						}
					);
					return;
				}

				const sendData = {
					userId: $scope.data.userId,
					profileId
				};
				AdminData.setUserMtProfile(sendData, function () {
					Utilities.showMessage(
						'Success',
						'The MT profile was added to the user',
						'success',
						function () {
							const addedProfile = $scope.data.mtProfiles.find(p => p.id === $scope.data.selectMTProfileId);
							$scope.data.userMtProfiles.push({
								profileId: addedProfile.id,
								profileName: addedProfile.name
							});
						}
					);
				}, function (error) {
					var errorMessage = 'There was a problem adding Mt profile to the user!';
					if (error.data && error.data.message) {
						errorMessage = 'There was a problem: <br />' + error.data.message;
					}
					Utilities.showMessage(
						'Problem!',
						errorMessage,
						'error'
					);
				});
			};

			/**
			 * remove MT profile from the user - UI part
			 * @param {*} profileId 
			 */
			$scope.removeMTProfile = function (profileId) {
				if (!profileId) return;

				SweetAlert.swal({
					title: 'Are you sure?',
					text: 'This will delete the Machine Tranbslation profile linked to the user',
					type: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#DD6B55',
					confirmButtonText: 'Yes, delete it!',
					cancelButtonText: 'No, cancel!',
					closeOnConfirm: true,
					closeOnCancel: true
				},
				function (isConfirm) {
					if (isConfirm) {
						$scope.__removeMTProfile(profileId);
					}
				});
			};

			/**
			 * remove MT profile from the user
			 * @param {*} profileId 
			 */
			$scope.__removeMTProfile = function (profileId) {
				const sendData = {
					userId: $scope.data.userId,
					profileId
				};
				AdminData.deleteUserMtProfile(sendData, function () {
					const removedProfileIndex = $scope.data.userMtProfiles.findIndex(p => p.profileId === profileId);
					if (removedProfileIndex > -1) {
						$scope.data.userMtProfiles.splice(removedProfileIndex, 1);
					}
				}, function (error) {
					var errorMessage = 'There was a problem removing Mt profile!';
					if (error.data && error.data.message) {
						errorMessage = 'There was a problem: <br />' + error.data.message;
					}
					Utilities.showMessage(
						'Problem!',
						errorMessage,
						'error'
					);
				});
			};

			$scope.init();
		}
	]);
